import { configStore } from "@/store/store-accessor";

export function getFrontendUrl(): string | undefined {
  return (
    configStore.previewedItem?.url ||
    configStore.documentSpecificNeededUrls?.frontend ||
    undefined
  );
}
